import React from 'react';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
import { Countdown } from './ui/Countdown';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <section className="py-20 bg-sky-900 border-t border-sky-800" data-id="element-87">
      <div className="container mx-auto px-4 text-center max-w-3xl" data-id="element-88">
        <div className="mb-10" data-id="element-89">
          <p className="text-red-400 font-bold uppercase tracking-wider mb-4" data-id="element-90">
            ⏰ EL PRECIO CIERRA EN:
          </p>
          <Countdown theme="danger" className="scale-110" data-id="element-91" />
        </div>

        <div className="space-y-6 mb-12" data-id="element-92">
          {/* Option 1 */}
          <div className="bg-sky-950/80 p-6 rounded-2xl border border-sky-800 shadow-lg flex flex-col sm:flex-row items-center justify-between gap-6" data-id="element-93">
            <div className="text-left" data-id="element-94">
              <h3 className="font-bold text-lg text-white" data-id="element-95">
                🌱 MEGAPACK ESTIMULACIÓN TEMPRANA LISTO
              </h3>
              <p className="text-sm text-sky-300" data-id="element-96">
                6 Tomos + 4 Bonos · De la incertidumbre al desarrollo con
                sistema
              </p>
            </div>
            <div className="flex flex-col items-center sm:items-end shrink-0" data-id="element-97">
              <div className="flex items-center gap-2 mb-2" data-id="element-98">
                <span className="text-sky-400/60 line-through text-sm" data-id="element-99">
                  $49.000
                </span>
                <span className="font-black text-xl text-white" data-id="element-100">
                  $19.990 ARS
                </span>
              </div>
              <a href="https://www.centralpack.shop/cart/53540579508542:1" target="_blank" rel="noopener noreferrer" data-id="element-101">
                <Button size="sm" variant="outline" data-id="element-102">
                  QUIERO MI MEGAPACK
                </Button>
              </a>
            </div>
          </div>

          {/* Option 2 */}
          <div className="bg-black p-6 rounded-2xl border-2 border-amber-400 shadow-xl flex flex-col sm:flex-row items-center justify-between gap-6 relative overflow-hidden" data-id="element-103">
            <div className="absolute top-0 right-0 bg-amber-400 text-slate-900 text-[10px] font-bold px-2 py-0.5 rounded-bl-lg" data-id="element-104">
              MÁS ELEGIDO
            </div>
            <div className="text-left" data-id="element-105">
              <h3 className="font-bold text-lg text-white" data-id="element-106">
                🚀 MEGAPACK + SISTEMA MAESTRO ⭐
              </h3>
              <p className="text-sm text-slate-400" data-id="element-107">
                6 Tomos + 4 Bonos + Acompañamiento Familiar Completo
              </p>
            </div>
            <div className="flex flex-col items-center sm:items-end shrink-0" data-id="element-108">
              <div className="flex items-center gap-2 mb-2" data-id="element-109">
                <span className="text-slate-500 line-through text-sm" data-id="element-110">
                  $69.000
                </span>
                <span className="font-black text-xl text-white" data-id="element-111">
                  $27.990 ARS
                </span>
              </div>
              <a href="https://www.centralpack.shop/cart/53540585111870:1" target="_blank" rel="noopener noreferrer" data-id="element-112">
                <Button size="sm" variant="primary" data-id="element-113">
                  QUIERO EL MEGAPACK + SISTEMA MAESTRO
                </Button>
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-sky-100 font-medium" data-id="element-114">
          <div className="flex items-center gap-1.5" data-id="element-115">
            <Lock className="w-4 h-4 text-sky-300" data-id="element-116" />
            <span data-id="element-117">Pago 100% seguro</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-118">
            <Zap className="w-4 h-4 text-amber-400" data-id="element-119" />
            <span data-id="element-120">Acceso en 5 minutos</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-121">
            <Shield className="w-4 h-4 text-emerald-400" data-id="element-122" />
            <span data-id="element-123">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-124">
            <CreditCard className="w-4 h-4 text-sky-300" data-id="element-125" />
            <span data-id="element-126">Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}